import type { IWorkerStatsRank } from '@/entities/worker-stats.entity';
import { DollarSignIcon, TrophyIcon } from 'lucide-react';

interface RankBadgesProps {
	byClients: IWorkerStatsRank;
	byProfit: IWorkerStatsRank;
}

function formatRank(rank: IWorkerStatsRank) {
	if (rank.total === 0) return null;
	return `#${rank.position} из ${rank.total}`;
}

export default function RankBadges({ byClients, byProfit }: RankBadgesProps) {
	const clientsRank = formatRank(byClients);
	const profitRank = formatRank(byProfit);

	if (!clientsRank && !profitRank) return null;

	return (
		<div className='flex flex-wrap gap-2'>
			{clientsRank && (
				<span className='inline-flex items-center gap-1.5 rounded-full bg-muted/60 px-3 py-1.5 text-xs font-medium'>
					<TrophyIcon size={12} className='text-chart-2' />
					{clientsRank} по клиентам
				</span>
			)}
			{profitRank && (
				<span className='inline-flex items-center gap-1.5 rounded-full bg-muted/60 px-3 py-1.5 text-xs font-medium'>
					<DollarSignIcon size={12} className='text-chart-5' />
					{profitRank} по профитам
				</span>
			)}
		</div>
	);
}
